module.exports = __webpack_public_path__ + "img/colors-square-1.d88515dc.svg";